// HUB-UI: native workspace screens share the customer portal chrome with ported grids.
// LegacyRuntime supplies the legacy Redux store used by ported content. BasicCli now
// delegates to LegacyHubFrame, which captures that store and gives only the chrome
// the Platform store. Native pages below receive the Platform store explicitly.
import { Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import BasicCli from '../main/components/basicCli/BasicCli';
import { store as platformStore } from './store';
export function LegacyShell() {
  return (
    <BasicCli>
      <Provider store={platformStore}>
        <Outlet />
      </Provider>
    </BasicCli>
  );
}
